type Handler = (s: string[]) => void;

export default class Batcher {
    private timeout: number;
    public buffer: any[];
    private handler: Handler;
    private timer?: NodeJS.Timer;

    public constructor(handler: Handler, timeout = 100) {
        this.timeout = timeout;
        this.buffer = [];
        this.handler = handler;
        this.send = this.send.bind(this);
    }

    public queue(data: any) {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.buffer.push(data);
        this.timer = setTimeout(this.send, this.timeout);
    }

    public send() {
        if (this.buffer.length === 0) {
            return;
        }
        // clearing timer here will because send is a flush
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.handler(this.buffer);
        this.buffer = [];
    }
}
